<div class="-m-6 flex max-h-screen max-w-240 flex-col md:min-w-160">
    <!-- Header -->
    <div class="flex h-16 flex-0 items-center justify-between bg-primary pl-6 pr-3 text-on-primary sm:pl-8 sm:pr-5">
        <div class="text-lg font-medium">{{ isEditMode ? 'Edit' : 'Add' }} Notes {{this.data.campName}}</div>
        <button mat-icon-button matDialogClose [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>

    <!-- Content -->
    <form class="flex flex-auto flex-col overflow-y-auto p-6 sm:p-8" [formGroup]="notesForm" (ngSubmit)="save()"
        novalidate>

        <mat-form-field class="w-full" subscriptSizing="dynamic">
            <mat-label>Notes</mat-label>
            <input matInput formControlName="notes" placeholder="Enter Notes" />
            <mat-error *ngIf="notesForm.get('notes')?.hasError('required')">
                Notes is required
            </mat-error>
        </mat-form-field>

        <!-- Is Completed -->
        <div>
        <br>
            <mat-slide-toggle class="mt-8 sm:ml-auto sm:mt-0" [color]="'primary'" formControlName="isCompleted" >
                Is Completed
            </mat-slide-toggle>
        <br>
        </div>
        <!-- Assigned To -->
        <mat-form-field class="mt-4 w-full" subscriptSizing="dynamic">
            <mat-label>Assigned To</mat-label>
            <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_outline:shield-check'"></mat-icon>
            <mat-select formControlName="assignedTo" placeholder="">
                <mat-option [value]="null">None</mat-option>
                @for (user of users; track trackByFn(user)) {
                <mat-option [value]="user.id">{{ user.name }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        <!-- Footer with actions -->
        <div
            class="mt-auto flex items-center justify-end space-x-3 border-t bg-gray-50 px-6 py-4 dark:bg-black dark:bg-opacity-10">
            <button mat-stroked-button type="button" (click)="close()">Cancel</button>
            <button mat-flat-button type="submit" [color]="'primary'" [disabled]="notesForm.invalid || isSubmitting"
                [attr.aria-busy]="isSubmitting">
                <mat-icon class="icon-size-4"
                    [svgIcon]="isSubmitting ? 'heroicons_outline:arrow-path' : 'heroicons_outline:check'"></mat-icon>
                <span class="ml-2 mr-1">{{ isSubmitting ? 'Saving...' : 'Save' }}</span>
            </button>
        </div>
    </form>
</div>